var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightServiceHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    fill: "none",
    viewBox: "0 0 15 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D3FF9A",
    d: "M15 4.5a.83.83 0 0 1-.831.831H.831a.83.83 0 1 1 0-1.662h13.338a.83.83 0 0 1 .83.831Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3FF9A",
    d: "M15 4.5a.828.828 0 0 1-.245.589l-3.243 3.23a.832.832 0 0 1-1.359-.908.832.832 0 0 1 .187-.27l2.652-2.64-2.652-2.642A.832.832 0 1 1 11.512.68l3.243 3.23A.829.829 0 0 1 15 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightServiceHub);
export default __webpack_public_path__ + "static/media/arrow-right-service-hub.63576960f83947de8e31360e4652ab0a.svg";
export { ForwardRef as ReactComponent };